module.exports = __webpack_public_path__ + "static/media/elips-check.a2b317c6.svg";